export const ja = {
  ADD_COLOR_STRING_KEY: '色の追加',
  ADD_TEXT_KEY: 'テキストの追加',
  ADD_TO_ORDER_KEY: '注文に追加',
  ADD_TO_CART: 'カートに追加',
  ADD_TEMPLATE: 'テンプレートの追加',
  ADJUST_SIZE_KEY: 'サイズの調整',
  ADJUST_TRANSPARENCY_KEY: '透明度を調整する',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    '[完了] をクリックすることにより、HP の利用条件およびプライバシーに関する声明に同意したことになります。',
  ALIGN_BOTTOM_KEY: '下揃え',
  ALIGN_CENTER_KEY: '中央揃え',
  ALIGN_KEY: '並べる',
  ALIGN_LEFT_KEY: '開始',
  ALIGN_MIDDLE_KEY: '中央揃え',
  ALIGN_RIGHT_KEY: '終了',
  ALIGN_TOP_KEY: '上揃え',
  ALL_TAB_TITLE_KEY: 'すべて',
  ALMOST_DONE_TITLE_KEY: 'まもなく完了です！',
  AND_KEY: 'と',
  APPLY_KEY: '適用',
  AREA_CODE: '市外局番',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'コンテンツを参照し、デザインに画像を選択する、または自身の画像をアップロード',
  BASIC_HELPER_INSTRUCTION2_KEY: 'デザインのプレビュー、またはディテールの調整',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'デザインのカスタマイズ、他のエレメントをプロジェクトに追加',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'デザインの準備ができたら、[次へ] をクリックして最終確認し、注文を実行します。',
  BACK_KEY: '戻る',
  BACKGROUND_KEY: '背景',
  BACKGROUND_UPPER_CASE_KEY: '背景',
  BACKGROUND_CONTRAST_KEY: '背景コントラスト',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'このカテゴリの下にインスピレーションは見つかりませんでした',
  BRING_TO_FRONT_KEY: '前面へ',
  CANCEL_TEXT_KEY: ' キャンセル ',
  CENTIMETERS_KEY: 'センチメートル',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'プロジェクト設定を変更する',
  CHECKBOX_CONTENT1: 'パターンデザイン©のニュースレターを受け取りたい',
  CHECKBOX_CONTENT2:
    '私は、HPが私のためにPattern Design©のサービスでアカウントを作成する権限を与えます',
  CHOOSE_FROM_COMPUTER_KEY: 'コンピュータから選択',
  CHOOSE_RIP_OPTIONS: 'これらの対応するサードパーティ RIP から一つ選択',
  CHOOSE_FILE_KEY: 'ファイルの選択',
  CITY: 'シティ',
  CLEAR_ALL_KEY: 'すべて消去',
  CLEAR_COLOR_KEY: '色の消去',
  CLOSE_WINDOW_KEY: 'ウィンドウを閉じる',
  CLEAR_ALL_OBJECTS: 'すべてのオブジェクトを消去',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'すべてのオブジェクトが背景から削除されます。',
  CLEAR_DESIGN_KEY: 'デザインの消去',
  COLOR_KEY: 'カラー',
  CONTINUE_KEY: '続行...',
  COMPANY: '会社',
  CONGRATULATIONS_KEY: '完了しました。',
  CONFIRM_PASSWORD: 'パスワードを認証する',
  CONFIRM_PATTERN_ACCOUNT_KEY:
    'Pattern Design アカウントをお持ちでないですか？',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: 'まだVecteezyアカウントを持っていませんか？',
  COUNTRY: '国',
  CREATE_ACCOUNT: 'アカウントを作成する',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'カスタム',
  CUSTOM_PRICE_SIGN_IN_KEY:
    'カスタム価格設定を表示するには次の手順でサインインします。',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: '新規作成',
  DESIGN_KEY: 'デザイン',
  DELETE_KEY: '削除',
  DOCUMENT_COLORS: 'ドキュメントの色',
  DONE: '完了！',
  DONE_KEY: '完了',
  DONT_SHOW_ALERT_KEY: '再度表示しない',
  DOWNLOAD_COLUMN_HEADER_KEY: 'ダウンロード',
  DOWNLOAD_APP_TITLE_KEY: 'App はこちらからダウンロードできます:',
  DOWNLOAD_LINK_KEY: 'こちらで無料で HP Click のダウンロード',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'HP SmartStream のダウンロード',
  DOWNLOAD_INSTR_KEY:
    '続行する前に HP Click をインストールしていることを確認してください',
  DOWNLOAD_SMARTSTREAM_KEY: 'HP SmartStream のダウンロード',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox インポート',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    '画像のサイズは 1 GB 未満である必要があります。pdf、png、jpg、svg、tiff 形式が使用できます。',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'ドリームタイム検索',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'ドリームタイム画像',
  DUPLICATE_KEY: '重複',
  EACH_ITEM_PRICE_KEY:
    'デザインにはプレミアム コンテンツ プロバイダによるコンテンツが含まれています。項目別に分けられた各要素の価格が下に要約されています。',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'デザインの編集',
  EDIT_LOWERCASE_KEY: '編集',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'エラーが発生しました。後でやり直してください。',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'アップロードされた PDF ファイルを開く際にエラーが発生しました。',
  EMAIL_KEY: '電子メール',
  EMAIL_ADDRESS_KEY: '電子メール アドレス:',
  EMAIL_CHECKBOX_MESSAGE:
    'このカスタマーには、私またはこのサービス プロバイダに代わって HP から電子メールが送られてくることを伝えています。',
  EXTRA_INFO_KEY: 'その他の情報',
  EMAIL_NOTIFICATION:
    'まもなくメールが送信されます。処理のために 15 分ほどお待ちください。',
  EMAIL_DIALOG_MESSAGE:
    'デザインを共有する相手の電子メールアドレスを入力してください。',
  ENTER_KEY: '実行',
  EXISTING_FOLDER_KEY: '既存のフォルダ',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'チェックアウト前に選択したアイテムが正しいことを確認してください',
  FINAL_CHECK_TITLE_KEY: '最終確認',
  FINISH_KEY: '終了',
  FINISH_LATER_KEY: '後で終了',
  FIRSTNAME: 'ファーストネーム',
  FISCAL_NUM: '会計番号',
  FLIP_KEY: '反転',
  FOR_KEY: 'にとって',
  FORGOT_PASSWORD_KEY: 'パスワードを忘れた場合',
  FOTOLIA_KEYWORDS_KEY: 'キーワード:',
  FOLDER_NAME: 'フォルダ名',
  FOLDER_NAME_KEY: 'フォルダ名:',
  FOLDER_ALREADY_EXIST_KEY: 'このフォルダ名はすでに存在します',
  FREE_POSTER_COMPLETE_MESSAGE_KEY: 'フリー ポスター デザインを完了しました',
  FREE_VECTOR_GRAPHICS_KEY: '無料のベクターグラフィック',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: '了解しました',
  GROUP_ALL_KEY: 'すべてグループ化',
  GROUP_SCALE: 'グループ スケール',
  GIFT_WRAPS_KEY: 'ギフトラッピング',
  GIVE_PROJECT_NAME_KEY: 'プロジェクトに名前を作成',
  HEIGHT_KEY: '高さ',
  TOUR_DESCRIPTION_TEXT:
    'デザイン プロセスをご案内します。ヘルプ アイコンをクリックして好きなときにツアーを再度開くことができます。',
  HELP_KEY: 'ヘルプ',
  HELPER_TITLE_KEY_1:
    '空白のページや数百万の画像やテキストからポスターデザインを作成します。 ローカルドライブ、Dropbox、ソーシャルメディアから自分のコンテンツをアップロードする',
  HELPER_TITLE_KEY_3: '1か所ですべてのデザイン作業を表示',
  HELPER_TITLE_KEY_4:
    '「次へ」をクリックして、最終的なデザインをプレビューし、',
  HERE_KEY: 'こちら',
  HELP_IMPROVE_KEY:
    '生産性と作業効率の向上や、カラープロダクションの拡大をサポートします。',
  HIGH_QUALITY_KEY: 'プロの現場で',
  IMAGES_TITLE_KEY: '画像',
  IMPERIAL_KEY: 'インペリアル',
  IMPORTING_KEY: 'インポート中',
  INCHES_COLUMN_HEADER_KEY: 'インチ',
  INCHES_KEY: ' インチ',
  INCHES_UNIT_STRING_KEY: 'インチ',
  INVALID_EMAIL_ADDRESS_KEY: '無効な電子メール アドレス',
  INVALID_INFO_KEY: '詳細を入力してください。',
  INVALID_NAME_KEY: '無効な名前',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    '選択したファイルが大きすぎます。ファイルの最大サイズは 500 mb です。',
  INSUFFICIENT_CREDITS_KEY: 'クレジット不足',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'インスピレーション',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    '有効なファイル形式ではありません。使用可能なファイルは pdf、jpg、png、tif です。',
  LANDSCAPE_KEY: '横方向',
  LANGUAGE_LABLE_KEY: '言語',
  LASTNAME: '苗字',
  LEARN_MORE: '詳細',
  LEARN_THE_BASICS_KEY: '基本の学習',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'このサイトを利用することにより、これらの条項に拘束されることに同意したことになります:',
  LEGAL_FOOTER_MESSAGE2_KEY: '本 Web サイトは次に準拠しています:',
  LEGAL_FOOTER_MESSAGE3_KEY: 'および',
  LENGTH_STRING_IN_INCHES_KEY: 'インチ',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: '変更',
  LINK_READER_APP_KEY: 'LinkReader アプリ',
  LINK_READER_APP_DESCRIPTION_KEY:
    '追加しているコンテンツを表示するには、LinkReader アプリをダウンロードしてください。',
  LOADING_KEY: 'ロード中...',
  LOADING_TEMPLATE_KEY: 'テンプレートの読み込み中',
  LOGIN_NOW: 'ここでログイン',
  LOCK_KEY: 'ロック',
  LOGIN_KEY: 'ログイン',
  LOGIN_PATTERN_DESIGN_KEY: 'Pattern design にログイン',
  LOGIN_SUBTITLE_KEY:
    'カスタマイズされた価格と支払い情報を見るにはログインしてください',
  LOGIN_VECTEEZY_KEY: 'Vecteezy にログイン',
  LOGIN_DREAMSTIME_KEY: 'Dreamstimeにログインする',
  LOGOUT_KEY: 'ログアウト',
  MATERIAL_TITLE_KEY: 'マテリアル',
  MATERIAL_STRING_KEY: 'マテリアル',
  MEASUREMENT_KEY: '測定',
  METRIC_KEY: 'メートル法',
  MOBILE: 'モバイル',
  MODEL_TITLE_KEY: 'モデル',
  MORE_INFO_TEXT_KEY: '詳細情報',
  MY_GIFTWRAPS_KEY: '私のギフトラップ',
  MY_WORK_KEY: 'マイワーク',
  MY_WORK_SAVE_KEY: 'デザインがマイワークスペースに保存されました',
  NAME_KEY: '名前:',
  NEXT_BUTTON_TITLE_KEY: '次へ',
  NEW_FOLDER_KEY: '新規フォルダ',
  NO_SHADOW_KEY: 'シャドウなし',
  OBJECT_QUANTITY_KEY: '量',
  OBJECTS_UPPER_CASE_KEY: 'オブジェクト',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'サンプルの注文',
  ORDER_SAMPLE: 'サンプルの注文',
  ORDER_SAMPLE_INFOLABEL_1: 'サンプルとして注文する画像を選択',
  ORDER_SAMPLE_INFOLABEL_2:
    'プロジェクトの実寸大のクローズアップ表示を含む電子メールを受け取ります',
  ORDER_SAMPLE_INFOLABEL_3: 'これは品質や解像度を評価するために役立ちます',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: '今すぐサンプルを注文',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'プロジェクトの品質や解像度を評価するため、プロジェクトの実寸大のクローズアップ表示を含む電子メールを受け取ります。',
  ORIENTATION_KEY: '方向',
  OTHER_PRINTING_OPTIONS: 'その他の印刷オプション',
  PASSWORD_KEY: 'パスワード',
  PATTERN_COLOR_KEY: 'パターン カラー',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'シームレス',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'pdf を作成できませんでした。やり直してください。',
  PHOTOS_KEY: '写真',
  PHOTO: '写真',
  PHONE: '電話',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    '私はこの画像の著作権を保持しており、次に同意します:',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    '画像のサイズは 500 MB 未満である必要があります。png、jpg、tiff、svg、pdf 形式が使用できます。',
  PIXEL_COLUMN_HEADER_KEY: 'ピクセル',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'ここにテキストを入力...',
  PLACEHOLDER_EXTRA_INFO_KEY: 'プリント ショップに送信が必要な重要情報',
  PLACEHOLDER_INCHES_STRING_KEY: 'インチ',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: '私のポスター',
  PORTRAIT_KEY: '縦方向',
  POSITION: '位置',
  PREMIUM_IMAGES_TITLE_KEY: 'プレミアム画像:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'プロジェクトの保存',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    '続行する前にプロジェクトの変更を保存する必要があります。',
  PRICE_COLUMN_HEADER_KEY: '価格',
  PRINTER_SERIAL_NUMBER_KEY: 'プリンタ シリアル番号*',
  PRINTING_ENABLE_DETAILS_KEY: '印刷を有効にするにはさらに少し詳細が必要です',
  PRINTER_MODELS_KEY: 'プリンタ モデル*',
  PROCESSING_KEY: '処理中...',
  PROCESSING_ALERT_TXT: 'デザインの処理中にこのウィンドウを閉じないでください',
  PROCESSING_ALERT_TXT2:
    '処理が完了したら、HP Click が自動的に開き、ファイルのダウンロードを開始します。',
  PROCESSING_DONE: 'まもなく完了です！',
  PROCESSING_FILE_TXT: 'ファイルの処理中です。',
  PROCESSING_TIME_TXT:
    '最高品質の画像にするために制作物を処理しているためこれには時間がかかる場合があります',
  PROCESSING_ALERT_TXT3: 'PDF はコンピュータに自動的にダウンロードされます',
  PROCESSING_ALERT_TXT4: '設定で自動化のために JDF 接続を構成できます',
  PREMIUM_CONTENT_KEY: 'プレミアム コンテンツ',
  PREVIEW_KEY: 'プレビュー',
  PROFESSIONAL_USE_TITLE_KEY: 'ベクター パターン。',
  PROJECT_NAME_KEY: 'プロジェクト名',
  PROJECT_NAME: 'プロジェクト名:',
  PROJECT_ALREADY_EXIST_KEY: 'このプロジェクト名はすでに存在します',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'このプロジェクト名はすでに存在します',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'このフォルダ名はすでに存在します',
  PIXELATION_WARNING_KEY: 'ピクセル化警告',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'アップロードした写真の解像度により、肌がゆがんだり歪んだりする場合があります。ぼやけがないことを確認するために、高品質の画像をアップロードし、画像の伸びを避けてください。プレビューに満足して続行したい場合は、引き続き送信してください。',
  REGISTER_CONTACTINFO: '連絡先',
  REGISTER_INFO: '登録情報',
  REGISTER_PATTERNSUB1: 'HPカスタマーの価値として、',
  REQUIRED_FIELDS_KEY: '必須フィールド',
  REQUIRED_FIELDS_TEXT_KEY: '必須フィールド',
  REQUIRED_STRING_KEY: '必須',
  RECOLOR_KEY: '色の変更',
  RADICALLY_SIMPLE_KEY: '非常にシンプルなプリンティング ソフトウェア',
  RIPSELECTION_HEAD:
    '今回が初めてです。優先する対応プリンティング ソフトウェアを選択してください。',
  RIPSELECTION_DESC:
    '選択内容は、今後の印刷出力のデフォルトの印刷パスになります。後で [設定] で変更可能です。',
  REGISTER_COMPANYINFO: '会社情報',
  REGISTER_KEY: '登録',
  REGISTER_NOW: '今すぐ登録',
  REOLOR_KEY: '色の変更',
  REQUEST_SAMPLE_KEY: 'Request a sample',
  RESIZE_KEY: 'サイズ変更',
  RESIZE_ARBITRARILY_KEY: '任意にサイズ変更',
  RESIZE_PROPORTIONALLY_KEY: '比例的にサイズ変更',
  REVIEW_AND_SUBMIT_KEY: 'レビューと送信',
  REQUEST_FOR_QUOTATION: '見積もり請求',
  RIGHT_LOGO_TEXT_KEY: '×',
  ROTATE_KEY: '回転',
  ROTATE_LEFT_KEY: '左 90°回転',
  ROTATE_RIGHT_KEY: '右 90°回転',
  ROTATION_KEY: '回転',
  ROWS_COLUMN_LABEL_STRING_KEY: '行と列',
  ROYALTY_FREE_KEY: '活躍する',
  ROYALTY_KEY: '王族',
  SALUTATION: '挨拶',
  SAVE_KEY: '保存',
  SAVING_KEY: '保存中...',
  SAVE_INSPIRATION: 'インスピレーションの保存',
  SAVE_TEMPLATE: 'テンプレートの保存',
  SAVE_DIALOG_TITLE: 'プロジェクトの保存',
  SAVE_PROJECT_NAME_KEY: '最初にプロジェクトを保存',
  SAVEDIALOG_MESSAGE:
    'ログインしてプロジェクトを保存してください。アカウントをお持ちでない場合は、簡単に登録できます。これまでの作業結果は失われません。',
  SEAMLESS_KEY: '高品質・',
  SCALE_INFO_STRING_KEY: 'デザインにフィットするよう画像のスケール変更',
  SCALE_KEY: 'スケール',
  SCALE_ALL_KEY: 'すべて拡大縮小',
  SCALE_TO_FILL_KEY: '一杯になるまでスケールを変更',
  SEARCH_BUTTON_TITLE_KEY: '検索',
  SELECT_CUSTOM_SIZE_KEY: 'カスタム サイズの選択',
  SELECT_CUSTOM_KEY: 'カスタム',
  SEARCH_TITLE: '検索',
  SELECTED_IMAGE_KEY: '選択した画像:',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'ギフトラッピングサイズを選択',
  SELECT_COUNTRY: '国を選択',
  SELECT_SALUTATION: '---選択---',
  SELECT_POSTER_SIZE_KEY: 'ポスターサイズを選択',
  SELECT_PRINTING_OPTION_KEY: '優先の印刷オプションを選択',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'インストール手順の送信',
  SEND_TO_BACK_KEY: '後ろへ',
  SEND_KEY: '送信',
  SEND_TO_PRINT_TITLE_KEY: '印刷に送信',
  SET_SIZE_KEY: 'サイズの設定',
  SETTINGS_KEY: '設定',
  SETTINGS_UPPERCASE_KEY: '設定',
  SHARE_KEY: '共有',
  SIGNED_IN_AS_KEY: 'サインイン名',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'カスタマイズされた価格と支払い情報を見るにはサインインまたは登録してください',
  SIGN_UP_NOW_KEY: '今すぐ申し込む',
  SKIP_KEY: 'スキップ',
  SOLID_COLORS_KEY: '無地',
  SQFT_UNIT_STRING_KEY: '平方フィート',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'ツアーの開始',
  STATUS_MSG: 'ファイルが印刷に送信されました！',
  SUBMIT_BUTTON_KEY: '提出する',
  SHARE_LINK_LABEL: '共有するリンクのタイプを選択',
  SHARE_EDIT_LINK: 'リンクの編集',
  SHARE_VIEW_LINK: 'リンクの表示',
  SHARE_YOUR_CREATION: '制作物を共有！',
  STREET_ADD: '住所',
  TARGET_VIEWING_HINT: '* ターゲット表示距離を設定値から変更できます。',
  TERMS1_KEY: '利用条件',
  TERMS2_KEY: 'HP のプライバシーに関する声明',
  TERMS3_KEY: 'HP 個人データ権限についての通知',
  TERMS_OF_USE_KEY: '利用条件',
  TERMS_OF_USE: '利用条件。',
  TEXT_SHADOW_COLOR_KEY: 'テキスト シャドウの色',
  TEXT_ANCHOR_MIDDLE: '中間',
  TEXT_UPPERCASE_KEY: 'テキスト',
  TILE_KEY: 'タイル',
  TOTAL_KEY: '合計',
  TOTAL_PRICE_KEY: '合計:',
  TRANSPARENCY_KEY: '透明性',
  TEMPLATES_KEY: 'テンプレート',
  TEMPLATES_UPPER_CASE_KEY: 'テンプレート',
  THANK_YOU_KEY: 'ありがとうございます',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'ロック解除',
  UNGROUP_KEY: 'グループ解除',
  UPDATE_TEXT_KEY: '更新',
  UPLOAD_KEY: 'アップロード',
  UPLOAD_LOGO_KEY: 'ロゴをアップロード',
  UPLOAD_IMAGE_KEY: '自身の画像をアップロード',
  UPLOAD_UPPERCASE_KEY: 'アップロード',
  USER_NAME: 'ユーザー名',
  USER_TYPE_TITLE_KEY: 'どのようなユーザーですか*',
  UNTILE_KEY: 'タイル解除',
  UNSPLASH_SEARCH_TITLE: 'Unsplash 検索',
  VALIDITY_KEY: '有効期限',
  VANILLA_LOGIN_DIALOG_KEY:
    '無料で参加でき、デザインを保存・印刷したり、保存した作業を表示したりできます。',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'デザインのプレビューです。続行する前に最終デザインを確認するか、編集を選択して変更を行います。',
  VAT_KEY: 'VAT',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'ロイヤルティフリーの',
  VIEW_FOTOLIA_KEY: 'Fotolia© で表示',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'デザインの詳細を表示',
  VIEW_DESIGNER_PROFILE_KEY: 'デザイナーのプロファイルを表示',
  VIEW_PRICE_KEY: '価格の表示',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy 検索',
  WALL_POSTER_KEY: 'ポスター',
  WALL_SIZE_TEXT_KEY: '壁のサイズ',
  WARNING_KEY: '警告',
  WEBSITE: 'ウェブサイト',
  WIDTH_KEY: '幅',
  YOU_CAN_ALWAYS_ACCESS: 'こちらでいつでもデザインにアクセスできます: ',
  YOUR_NAME_KEY: 'あなたの名前',
  YOUR_SELECTION_WILL_KEY:
    '選択内容は、今後の印刷出力のデフォルトの印刷パスになります。',
  YOUR_PROJECT_KEY: 'プロジェクト:',
  PROJECT_NAME_ERROR_TEXT: 'プロジェクトの名前を入力してください。',
  PROJECT_FOLDER_ERROR_TEXT: 'プロジェクト フォルダの名前を入力してください。',
  PIXELATION_WARNING_SETTINGS_KEY: 'ピクセル化警告設定',
  MINIMUM_VIEWING_DISTANCE_KEY: '最小表示距離',
  BACKGROUND_UPLOAD_KEY: '背景',
  OBJECT_UPLOAD_KEY: 'オブジェクト',
  PHOTO_UPLOAD_KEY: '写真',
  NO_DREAMSTIME_ERROR_MESSAGE: 'dreamstimeは見つかりませんでした',
  NO_ELEMENT_ERROR_MESSAGE: '要素が見つかりません。',
  NO_MORE_IMAGES_FOUND_KEY: 'これ以上画像が見つかりません',
  NO_PATTERN_ERROR_MESSAGE: 'パターンが見つかりません。',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  ALREDY_HAVE_AN_ACCOUNT: '既に {0} アカウント？',
  CHANGE_MEASURING_SYSTEM_KEY: '{0} に変更',
  DOWNLOADS_KEY: '{0} ダウンロード',
  HEX_COLOR_KEY: '六角の色: {0}',
  NEAR_KEY: '近く',
  FAR_KEY: '遠く',
  CLOSE_UP_KEY: '閉じる',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    '使用しようとしている画像は、使用しているデザイン領域よりも小さいか大きいです。',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'より良い結果を得るには、999解像度の画像を使用してください',
  MESSAGE_KEY: 'メッセージ:',
  VIEWS_KEY: '{0} 再生回数',
  COST_DESCRIPTION_MESSAGE_KEY:
    'これは、デザインに含まれるプレミアム コンテンツに関連する費用のサマリーです。{0} 選択することにより、コンテンツ プロバイダにより次の費用が請求されることに同意したことになります。',
  DEFAULT_PRINTING_OPTION_KEY: '{0} あなたのデフォルトの印刷オプションです。',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' $ 100相当の高解像度画像が再現されます {0} すべてのあなたの創造的なニーズに役立ちます！',
  REGISTER_PATTERNSUB3:
    '今すぐ登録して次の30日間をかけて、2500万枚の写真ベースのコンテンツファイルからクリエイティブファイルをダウンロードし、 {0} 創造的なニーズを満たすのに役立ちます。',
  ZOOM_WARNING_PIXELATED_TEXT:
    'このスケールでは、{0} {1} の距離で見たときに印刷された画像にピクセルが見える可能性があります * (現在の印刷解像度は {2}dpi です)。',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    '推奨の表示距離は {0} {1} です。これが適切でない場合は、この画像のスケールまたは壁のサイズを小さくしてください。',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    '画像の推奨最小サイズは {0} × {1} ピクセルです。',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: '登録する {0}',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY: '最小寸法は {0} (幅) ×{1} (高さ) です。',
  MINIMUM_HEIGHT_KEY: '最小高さは {0} です。',
  MINIMUM_WIDTH_KEY: '最小幅は {0} です。',
  MAXIMUM_DIMENSIONS_KEY: '最大寸法は {0} (幅) ×{1} (高さ) です。',
  MAXIMUM_WIDTH_KEY: '最大幅は {0} です。',
  MAXIMUM_HEIGHT_KEY: '最大高さは{0}です。',
  INVALID_NUMBER_ERROR_TEXT_KEY: '0 より大きい寸法値を入力してください。',
  PROCESSING_FAILED: '処理に失敗しました。しばらくしてからやり直してください。',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    '複数ページの PDF はサポートされていません。',
  MINIMUM_ZOOM_WARNING:
    'この背景は、壁を覆うのに必要な最小の高さまたは幅に達しているため、これ以上縮小できません。',
  OF_KEY: 'の',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: '暗号化されたPDFはサポートされていません。',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'ファイル {0} / {1} をインポートしています',
  RECOLORING_KEY: '色の変更中...',
  TEXT_COLOR_KEY: 'テキストの色',
  SOLID_COLOR_KEY: '無地',
  AUTHENTICATE_DIALOG_TITLE:
    'このコンテンツ ソースはパスワードで保護されています',
  AUTHENTICATE_FAILED_MESSAGE: '認証に失敗しました！',
  DROPBOX_IMPORT_ERROR_HEADER:
    '一部のファイルのインポート中に問題が発生しました。',
  MATERIAL_CHOICE_APPLIED: '材料の選択が適用されます。',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'このインスピレーションテンプレートのデフォルトサイズは{0} X {1} {2}です。 このテンプレートに合わせてページサイズが自動的に変更されます。',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'プロジェクト',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'あなたのラップトップを選択する',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: '必須項目を入力してください',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'あなたの詳細',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: '通知:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'PCスキンを完全にカスタマイズするには、請求書に記載されているように、購入に対応する正確なモデルを選択する必要があります。',
  RESTART_PROJECT_ALERT_TITLE: 'プロジェクトを再起動しますか？',
  DISCARD_ALERT_MESSAGE: '現在のプロジェクトは破棄されます',
  RESTART: '再起動',
  BLOCKCHAIN_STRING: 'ブロックチェーン',
  CERTIFICATE_STRING: '証明書',
  AUTHENTICITY_STRING: '信憑性',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'ページサイズ警告！',
  MODIFY_SIZE_WARNING:
    'このデザインのサイズを変更する場合は、[設定]タブで変更できます。 設計要素は、目的の寸法に調整するために編集が必要になる場合があります。',
  RANDOMIZE_KEY: 'ランダム化',
  PLEASE_WAIT: 'お待ちください',
  PROTECTING_YOUR_DATA: 'データを保護する...',
  SEARCH_YOUR_LAPTOP_KEY: 'ラップトップを検索する', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'おっとっと！ 検索対象のノートパソコンが見つかりませんでした。', // Google translated
  SERIAL_NUMBER_KEY: 'シリアル番号',
  LOCKED_PROJECT: 'ロックされたプロジェクト',
  LOCKED_MESSAGE:
    'このプロジェクトは注文されており、変更できません。プロジェクトは表示専用です。',
  EXPIRED_PROJECT: '期限切れプロジェクト',
  EXPIRED_MESSAGE: 'このプロジェクトの期限が切れました。',
  DELETED_PROJECT: '削除済みプロジェクト',
  DELETED_MESSAGE: 'このプロジェクトは削除されています。',
  CHOOSE_GROUP_TYPE: '{0} 種類の選択',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: '0 より大きい数字を入力してください。',
  SIZE_KEY: 'サイズ',
  DISTANCE_FROM_KEY: '次からの距離:',
  MYROOM_UPPERCASE_KEY: '私の部屋',
  FURNITURE_KEY: '備品',
  FIXTURES_KEY: '備品',
  ADD_A_WALL_KEY: '壁の追加',
  SELECT_A_WALL_KEY: '壁の選択',
  LEFT_KEY: '左',
  RIGHT_KEY: '右',
  DELETE_WALL_KEY: '壁の削除',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'キャンバスタイプを選択',
  MAXIMUM_WALL_SIZE_KEY: '壁の最大サイズは {0} 平方 {1} です。',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'キャンバスの高さが壁の高さを超えています。',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'キャンバスの幅が壁の幅を超えています。',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY: '現在の幅での最大列数は {0} です',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY: '現在の高さでの最大行数は {0} です',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    '壁の幅がキャンバスの幅より小さくなっています。',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: '壁の最小幅は {0} {1} です。',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: '壁の最小高さは {0} {1} です。',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    '壁の高さがキャンバスの高さより小さくなっています。',
  MAXIMUM_WALL_HEIGHT_KEY: '壁の最大高さは {0} {1} です。',
  FINISHING_KEY: '仕上げ',
  MIRROR_KEY: 'ミラー',
  NATURAL_KEY: 'ナチュラル',
  ROWS_KEY: '行',
  COLUMNS_KEY: '列',
  DEFAULT_WALL_SIZE_KEY: 'デフォルトの壁サイズ',
  EDIT_KEY: '編集',
  TOP_KEY: 'トップ',
  BOTTOM_KEY: 'ボトム'
};
